import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import login_image from '../assets/images/login_image01.jpg';
// import login_image from '/assets/images/login_generated.png';
import signinwidget from '../assets/images/signin-widget.png';
import rubicrlogo from '../assets/images/rubicr-prouct-logo-blue.png';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    setError('');

    const defaultEmail = 'vivek@impactree.ai';
    const defaultPassword = 'Argus@123';

    const users = JSON.parse(localStorage.getItem('users') || '[]');
    const user = users.find(u => u.email === email && u.password === password);

    if ((email === defaultEmail && password === defaultPassword) || user) {
      const userData = user || { email: defaultEmail, name: 'Vivek', role: 'Safety Manager' };
      localStorage.setItem('currentUser', JSON.stringify(userData));
      navigate('/module-selection-dashboard');
    } else {
      setError('Invalid email or password');
    }
  };

  return (
    <div className="h-screen bg-white flex overflow-hidden">
      <div className="w-1/2 h-full p-4">
        <img
          src={login_image}
          alt="Argus Login"
          className="w-full h-full object-cover rounded-lg"
        />
      </div>

      <div className="w-1/2 flex items-center justify-center">
        <form onSubmit={handleLogin} className="signin-container" style={{ width: '500px', marginTop: '-50px' }}>
          <div className="text-center relative" style={{ height: '330px', width: '500px' }}>
            <img
              src={signinwidget}
              alt="Green Globe"
              className="h-full w-full object-contain"
            />
            <div
              style={{
                position: 'absolute',
                width: '100px',
                height: '27px',
                top: '126px',
                left: '50%',
                transform: 'translateX(-50%)',
              }}
            >
              <img src={rubicrlogo} alt="Rubicr Logo" className="w-full h-full object-contain" />
            </div>
            <div className="welcome-box" style={{ position: 'absolute', bottom: '70px', left: '0', right: '0' }}>
              <h1 className="text-[32px] font-bold mb-0">Welcome Back</h1>
              <h5 className="text-base text-[#ACACAC] font-medium text-[16px] mt-2">
                Enter your login credentials to access your account
              </h5>
            </div>
          </div>

          <div className="flex flex-col items-center" style={{ marginTop: '-40px' }}>
            <div className="mt-2">
              <label className="block text-sm font-medium mb-2" style={{ textAlign: 'left', width: '417px' }}>Username</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-control px-4 py-2  border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                placeholder="Enter your email address"
                required
              />
            </div>
            <div className="mt-2">
              <label className="block text-sm font-medium mb-2" style={{ textAlign: 'left', width: '417px' }}>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-control px-4 py-2  border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                placeholder="Enter your password"
                required
              />
            </div>
          </div>

          <div className="flex justify-between items-end mb-5 mt-4" style={{ width: '417px', margin: '16px auto 20px auto' }}>
            {/* <label className="flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                className="mr-2 cursor-pointer"
              />
              <span className="text-sm">Remember me</span>
            </label> */}
            {/* <a
              href="/signup"
              className="text-warning-custom"
            >
              Sign up?
            </a> */}
          </div>

          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4 text-sm text-center" style={{ width: '417px', margin: '0 auto 16px auto' }}>
              {error}
            </div>
          )}

          <div className="flex justify-center items-center">
            <button
              type="submit"
              className="figma-btn"
            >
              Login to account
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;